import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { SidebarIcon } from './SidebarIcon';
import { useSidebar } from './SidebarContext';
import { ProfileMenu } from './ProfileMenu';
import { usePermissions } from '../../shared/lib/permissionsContext';
import * as S from './Sidebar.styles';
import { S3Icon } from '../../shared/ui';

export const Sidebar: React.FC = () => {
  const { expanded, toggleSidebar } = useSidebar();
  const location = useLocation();
  const { hasPageAccess, permissions, loading } = usePermissions();

  const allIcons = [
    { id: 'tickets', icon: <S3Icon iconName="ListTask" width={22} height={22} />, label: 'Тикеты', path: '/tickets', page: 'tickets' },
    { id: 'search', icon: <S3Icon iconName="Search" width={22} height={22} />, label: 'Поиск', path: '/search', page: 'search' },
    { id: 'templates', icon: <S3Icon iconName="Document" width={22} height={22} />, label: 'Шаблоны', path: '/templates', page: 'templates' },
    { id: 'categories', icon: <S3Icon iconName="Layer" width={22} height={22} />, label: 'Категории', path: '/categories', page: 'categories' },
    { id: 'clients', icon: <S3Icon iconName="Users" width={22} height={22} />, label: 'Клиенты', path: '/clients', page: 'clients' },
    { id: 'admin', icon: <S3Icon iconName="AdministratorLine" width={22} height={22} />, label: 'Админка', path: '/admin', page: 'admin' },
  ];

  const icons = loading ? [] : allIcons.filter(icon => {
    if (icon.page === 'admin') {
      return permissions?.is_superuser || false;
    }
    return hasPageAccess(icon.page);
  });

  const brandBlue = "#0d6efd";

  return (
    <S.SidebarContainer>
      <S.BlueHeaderSection>
        <S.WaveContainer>
          <S.WaveSVG
            viewBox="0 0 500 150"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0 L500,0 L500,80 C400,140 300,40 150,110 C80,140 0,100 0,80 Z"
              fill={brandBlue}
            />
          </S.WaveSVG>
        </S.WaveContainer>
      </S.BlueHeaderSection>

      <S.SidebarIconsContainer>
        <S.TopIconsContainer>
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <S.CRMLogoBadge $expanded={expanded}>
              <S.CRMLogoText $expanded={expanded}>CRM</S.CRMLogoText>
            </S.CRMLogoBadge>
          </Link>
        </S.TopIconsContainer>

        <S.MiddleIconsContainer $expanded={expanded}>
          {icons.map((item) => {
            const isActive = item.path === '/' 
              ? location.pathname === '/' 
              : location.pathname.startsWith(item.path);
            return (
              <S.SidebarIconLink
                key={item.id}
                to={item.path}
                $active={isActive}
              >
                <SidebarIcon
                  icon={item.icon}
                  label={item.label}
                  expanded={expanded}
                  active={isActive}
                />
              </S.SidebarIconLink>
            );
          })}
        </S.MiddleIconsContainer>
      </S.SidebarIconsContainer>
      
      <S.SidebarProfileContainer>
        <S.SidebarToggleButton
          $expanded={expanded}
          onClick={toggleSidebar}
          title={expanded ? 'Свернуть' : 'Развернуть'}
        >
          <S.SidebarToggleIcon>
            {expanded ? '◀' : '▶'}
          </S.SidebarToggleIcon>
          {expanded && (
            <S.SidebarToggleLabel>Свернуть</S.SidebarToggleLabel>
          )}
        </S.SidebarToggleButton>
        <ProfileMenu />
      </S.SidebarProfileContainer>
    </S.SidebarContainer>
  );
};
